import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import Message from './Message';

class Feed extends Component {
    constructor(props) {
        super(props);
        this.scrollChat = this.scrollChat.bind(this);
    }
    scrollChat(){
        const node = findDOMNode(this.refs.chatListRef);
        const currentScroll = document.documentElement.scrollTop ||document.body.scrollTop;
        if(currentScroll > 100) {
            window.scrollTo(0, node - (currentScroll/5));
        }
    }
    componentDidMount(){
        this.scrollChat();
    }
    render(){
        return (
            <div className="messages" ref='chatListRef'>
             {/*
                 messages.map((m) => {
                     return <Message key={m.id} />
                 })
                */}
                <Message />
            </div>
        )
    }
}

export default Feed;


// WEBPACK FOOTER //
// ./src/components/chat/Feed.js